import "./assignee";
import "./conversation-sources";
import "./created-date";
import "./last-response-date";
import "./priority";
import "./queues";
import "./request-type";
import "./requester";
import "./search";
import "./statuses";
import "./tags";
import "./unread";

import { FILTER_REGISTRY } from "./base";

export default FILTER_REGISTRY;
